import { MinimalRate } from '../legos/financingTypes';

/**
 * Return min and max limit based on array of rates
 *
 * @param rates - List of minimal rates
 * @returns array with min limit first and max limit last
 */
export function getFinanceAmountLimits(rates: MinimalRate[]) {
  return [
    Math.min(...rates.map(rate => rate.minFinanceAmount)),
    Math.max(...rates.map(rate => rate.maxFinanceAmount)),
  ];
}

/**
 * Return min and max limit based on array of rates
 *
 * @param rates - List of minimal rates
 * @returns array with min limit first and max limit last
 */
export function getDownPaymentAmountLimits(
  rates: Pick<MinimalRate, 'minDownPaymentAmount' | 'maxDownPaymentAmount'>[],
) {
  if (rates.length === 0) {
    // If there are no rates, then return the bare min/max down payment limits
    return [0, Infinity];
  }
  return [
    Math.min(...rates.map(rate => rate.minDownPaymentAmount ?? 0)),
    Math.max(...rates.map(rate => rate.maxDownPaymentAmount ?? Infinity)),
  ];
}
